module.exports = __webpack_public_path__ + "media/icons/sprowadzony-grey-8de8fce2.png";